import classNames from 'classnames';
import { useId } from 'hooks';
import './index.css';

function Monogram({ highlight, className, ...props }) {
  const id = useId();
  const clipId = `monogram-clip-${id}`;

  return (
    <svg
      aria-hidden
      className={classNames('monogram', className)}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...props}
    >
      <defs>
        <clipPath id={clipId}>
          <path d="M28.34 28.355C28.79 29.045 29.255 29.6 29.735 30.02C30.215 30.44 30.83 30.8 31.58 31.1V32C29.48 31.91 27.14 31.865 24.56 31.865C22.58 31.865 20.675 31.91 18.845 32V31.1C19.685 31.04 20.285 30.95 20.645 30.83C21.035 30.71 21.23 30.5 21.23 30.2C21.23 29.96 21.065 29.585 20.735 29.075L14.21 18.5C13.61 17.54 13.1 16.895 12.68 16.565C12.29 16.235 11.75 16.04 11.06 15.98V27.23C11.06 28.37 11.135 29.195 11.285 29.705C11.465 30.215 11.78 30.56 12.23 30.74C12.68 30.92 13.415 31.04 14.435 31.1V32C12.815 31.91 10.55 31.865 7.64 31.865C4.43 31.865 2.06 31.91 0.53 32V31.1C1.52 31.04 2.24 30.92 2.69 30.74C3.17 30.56 3.485 30.215 3.635 29.705C3.815 29.195 3.905 28.37 3.905 27.23V4.91C3.905 3.77 3.815 2.945 3.635 2.435C3.485 1.925 3.17 1.58 2.69 1.4C2.24 1.22 1.52 1.1 0.53 1.04V0.14C2.06 0.229999 4.43 0.274998 7.64 0.274998C10.55 0.274998 12.815 0.229999 14.435 0.14V1.04C13.415 1.1 12.68 1.22 12.23 1.4C11.78 1.58 11.465 1.925 11.285 2.435C11.135 2.945 11.06 3.77 11.06 4.91V15.035C12.26 14.975 13.355 14.615 14.345 13.955C15.335 13.295 16.46 12.245 17.72 10.805L20.375 7.61C21.755 6.02 22.445 4.625 22.445 3.425C22.445 2.705 22.145 2.135 21.545 1.715C20.975 1.295 20.165 1.055 19.115 0.995V0.14C21.305 0.229999 23.525 0.274998 25.775 0.274998C27.515 0.274998 28.925 0.229999 30.005 0.14V0.995C27.605 1.565 25.43 3.005 23.48 5.315L17.855 12.02L28.34 28.355Z" />
        </clipPath>
      </defs>
      <rect clipPath={`url(#${clipId})`} width="100%" height="100%" />
      {highlight && (
        <g clipPath={`url(#${clipId})`}>
          <rect className="monogram__highlight" width="100%" height="100%" />
        </g>
      )}
    </svg>
  );
}

export default Monogram;
